import { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "./auth-context";

export default function ProtectedRoutes() {
  const authenticationContext = useContext(AuthContext)!;
  const location = useLocation();

  if (!authenticationContext.isAuthenticated()) {
    return <Navigate to={`/login/${location.pathname}`} replace />;
  }

  return <Outlet />;
}
